import HomeHeader from "../Component/HomeComponent/HomeHeader";
import styled, { keyframes, css } from "styled-components";
import { useState, useEffect, useRef } from "react";
import ShowCaseCardRow from "../Component/HomeComponent/ShowCaseCardRow";
import { Col, Row, Button } from "antd";

import { ServicesData } from "./StaticData/HomeServiceData";

import HomeFooter from "../Component/HomeComponent/HomeFooter";
import { useNavigate } from "react-router-dom";

import ReactPlayer from "react-player";
import {
  PageContainer,
  SectionContainer,
  TitleContainer,
  DetailsContainer,
  FirstSectionContainer1,
  SubPageTitle,
  VideoBackground,
} from "../Component/HomeComponent/GeneralComponents";
import { createFromIconfontCN, TeamOutlined } from "@ant-design/icons";
import AboutUs from "../Component/HomeComponent/AboutUs";
import { gql, useQuery } from "@apollo/client";
import { getUrl } from "aws-amplify/storage";

const IconFont = createFromIconfontCN({
  scriptUrl: "//at.alicdn.com/t/c/font_4531892_qm19xvlhz3n.js",
});

const GET_PROJECTS = gql`
  query GetProjects {
    home_page_project {
      id
      title
      image
      link
    }
  }
`;

export default function Home() {
  const [ismobile, setIsMobile] = useState(0);
  const moveTitleRef = useRef();
  const [bgVideoUrl, setBgVideoUrl] = useState("");
  const navigate = useNavigate();

  const [projects, setProjects] = useState([]);
  const { data } = useQuery(GET_PROJECTS);

  function ScrollToElement(navigation) {
    const Element = document.getElementById(navigation);
    if (Element) {
      Element.scrollIntoView({ behavior: "smooth" });
    }
  }

  useEffect(() => {
    const fetchS3Url = async (path) => {
      if (!path || !path.startsWith("websitePicture/")) return path;
      try {
        const { url } = await getUrl({
          key: path,
          options: {
            expiresIn: 3600,
          },
        });
        return url.href;
      } catch (error) {
        console.error("Fetch S3 URL failed:", error);
        return path;
      }
    };
    const processProjectImages = async () => {
      if (!data?.home_page_project) return;
      const processedProjects = await Promise.all(
        data.home_page_project.map(async (project) => {
          const imageUrl = await fetchS3Url(project.image);
          return {
            ...project,
            image: imageUrl,
          };
        })
      );
      setProjects(
        processedProjects.filter(
          (project) =>
            project.id === "60e73e0e-0986-4a13-8887-0b147b93694a" ||
            project.id === "6cd075ec-1c29-403a-b59c-9d6034c2d79f" ||
            project.id === "52e95777-80ae-4e19-8554-48ad17f98d22" ||
            project.id === "cbe0fe0e-f903-434d-bf51-0b2ce0f7a11f" ||
            project.id === "3d7c700d-9017-4fbc-a35f-66b6cc8d66bb" ||
            project.id === "3e51c4d8-2d13-436f-83f4-550980a53469"
        )
      );
    };
    if (data?.home_page_project) {
      processProjectImages();
    }
  }, [data]);

  useEffect(() => {
    const handleMouseMove = (event) => {
      const { clientX } = event;
      const dx = (window.innerWidth / 2 - clientX) / 100;

      moveTitleRef.current.style.transform = `translateX(${dx}px)`;
    };

    window.addEventListener("mousemove", handleMouseMove);

    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
    };
  }, []);

  useEffect(() => {
    const handleResize = () =>
      setIsMobile(window.innerHeight > window.innerWidth ? 1 : 0);
    window.addEventListener("resize", handleResize);
    // Call handleResize right away so that ismobile is set correctly initially
    handleResize();
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  useEffect(() => {
    setTimeout(() => {
      const hash = window.location.hash;
      if (hash) {
        const id = hash.substring(1);
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ block: "end", behavior: "smooth" });
        }
      }
    }, 100);
  }, []);
  useEffect(() => {
    const fetchVideoUrl = async () => {
      setBgVideoUrl("https://youtu.be/CvIWO1hy254");
    };
    fetchVideoUrl();
  }, []);

  return (
    <PageContainer>
      <HomeHeader />
      <FirstSectionContainer1
        ismobile={ismobile}
        id="main"
        style={{ position: "relative", overflow: "hidden" }}
      >
        <VideoBackground>
          <ReactPlayer
            url={bgVideoUrl}
            playing
            loop
            muted
            width="100%"
            height="100%"
            className="react-player"
            playsinline
            config={{
              youtube: {
                playerVars: {
                  controls: 0,
                  showinfo: 0,
                  rel: 0,
                  modestbranding: 1,
                  iv_load_policy: 3,
                  playsinline: 1,
                  vq: "hd1080",
                  hd: 1,
                  quality: "hd1080",
                },
              },
              file: {
                attributes: {
                  style: {
                    objectFit: "cover",
                    width: "100%",
                    height: "100%",
                  },
                },
              },
            }}
          />
        </VideoBackground>

        <div ref={moveTitleRef} style={{ position: "relative", zIndex: 2 }}>
          <TitleContainer ismobile={ismobile} style={{ paddingTop: "15vh" }}>
            <div>Where</div>
            <div>Construction</div>
            <div>Meets Innovation</div>
          </TitleContainer>
          <DetailsContainer
            ismobile={ismobile}
            style={{
              paddingTop: ismobile ? "10vh" : "10vh",
              width: ismobile ? "80vw" : "30vw",
              fontWeight: 200,
              lineHeight: 1.2,
            }}
          >
            <div>
              At RF Sons Engineering, we specialize in leveraging digital tools
              to innovate construction processes.
            </div>

            <RoundButton
              ismobile={ismobile}
              onClick={() => {
                ScrollToElement("project");
              }}
              style={{ marginTop: ismobile ? "15vh" : "10vh" }}
            >
              Learn More
            </RoundButton>
          </DetailsContainer>
        </div>
        <Row
          style={{
            position: "absolute",
            bottom: "8vh",
            width: "100%",
            display: ismobile ? "none" : "flex",
            paddingLeft: "10%",
            paddingRight: "10%",
            zIndex: 2,
          }}
        >
          <StyledCol span={8} delay={0}>
            <StyledButton
              onClick={() => {
                ScrollToElement("project");
              }}
              type="text"
              icon={<IconFont type="icon-portfolio" />}
            >
              Project
            </StyledButton>
          </StyledCol>
          <StyledCol span={8} delay={0.25}>
            <StyledButton
              onClick={() => {
                ScrollToElement("services");
              }}
              type="text"
              icon={<IconFont type="icon-jianmo" />}
            >
              Services
            </StyledButton>
          </StyledCol>
          <StyledCol span={8} delay={0.5}>
            <StyledButton
              onClick={() => {
                ScrollToElement("about");
              }}
              type="text"
              icon={<TeamOutlined />}
            >
              About Us
            </StyledButton>
          </StyledCol>
        </Row>
      </FirstSectionContainer1>

      <SectionContainer id="project" paddingTop="3vh">
        <SubPageTitle
          ismobile={ismobile}
          style={{
            paddingBottom: 0,
            marginLeft: 0,
          }}
        >
          Our Project
        </SubPageTitle>

        <ShowCaseCardRow>{projects}</ShowCaseCardRow>
        <div
          style={{ display: "flex", justifyContent: "center", width: "100%" }}
        >
          <GlowButton onClick={() => navigate("/home_project")}>
            View all projects
          </GlowButton>
        </div>
      </SectionContainer>
      <SectionContainer id="services">
        <SubPageTitle
          ismobile={ismobile}
          style={{
            paddingTop: ismobile ? "1.5vh" : "3vh",
            paddingBottom: 0,
            marginLeft: 0,
          }}
        >
          Our Services
        </SubPageTitle>
        <ShowCaseCardRow>{ServicesData}</ShowCaseCardRow>
      </SectionContainer>
      <AboutUs ismobile={ismobile} />
      <HomeFooter />
    </PageContainer>
  );
}

const ripple = keyframes`
  0% {
    box-shadow: 0 0 0 0 rgba(2, 138, 138, 0.4);
  }

  100% {
    box-shadow: 0 0 0 35px rgba(2, 138, 138, 0);
  }
`;
const fadeInFromBottom = keyframes`
  0% {
    opacity: 0;
    transform: translateY(50px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
`;

const RoundButton = styled(Button)`
  display: ${(props) => (props.ismobile ? "block" : "none")};
  background-color: transparent;
  border: 1px solid white;
  padding: 20px 30px;
  height: auto;
  margin-top: 5vh;
  color: white;
  white-space: wrap;
  font-size: calc(100vh * 14 / 720);
  animation: ${ripple} 1.5s infinite;
`;
const StyledCol = styled(Col)`
  display: flex;
  justify-content: center;
  align-items: center;
  animation: ${fadeInFromBottom} 2s ease-out;
  animation-delay: ${(props) => props.delay || 0}s;
  animation-fill-mode: backwards;
`;
const StyledButton = styled(Button)`
  font-size: calc(
    100vh * ${(props) => (props.ismobile ? 20 : 20)} /
      ${(props) => (props.ismobile ? 720 : 1080)}
  );

  background-color: transparent;
  color: white;
  &&:hover {
    color: #18dcff !important;
    background-color: transparent !important;
  }
`;
const GlowButton = styled(Button)`
  font-size: calc(
    100vh * ${(props) => (props.ismobile ? 20 : 24)} /
      ${(props) => (props.ismobile ? 720 : 1080)}
  );
  padding-top: 5vh;
  padding-bottom: 5vh;
  padding-left: 5vw;
  padding-right: 5vw;
  margin-bottom: 10vh;
  background-color: transparent;
  color: white;
  animation: ${(props) =>
    props.ismobile
      ? "none"
      : css`
          ${ripple} 1.5s infinite
        `};
  border: 1px solid white;
  border-width: ${(props) => (props.ismobile ? "0px" : "1px")};
  &&:hover {
    background-color: transparent !important;
    color: #18dcff !important;
  }
`;
